export default __webpack_public_path__ + "static/media/ART.48ba7d51.jpeg";